module.exports = __webpack_public_path__ + "static/media/Avatar.c0f11ec2.jpg";